import { render, staticRenderFns } from "./PrintBadgeButton.vue?vue&type=template&id=da535198"
import script from "./PrintBadgeButton.vue?vue&type=script&lang=ts"
export * from "./PrintBadgeButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports